import RichTextEditor from './rich-editor'
export default RichTextEditor
